import { render, staticRenderFns } from "./MesaContaPagamentoForm.vue?vue&type=template&id=5cab3dcf&scoped=true"
import script from "./MesaContaPagamentoForm.vue?vue&type=script&lang=js"
export * from "./MesaContaPagamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab3dcf",
  null
  
)

export default component.exports